var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "xyjmw48oba",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#30ACC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3077C1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#xyjmw48oba)",
    fillRule: "nonzero",
    transform: "translate(-765 -288)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 1.28C4.294 1.28 1.28 4.295 1.28 8c0 3.705 3.015 6.72 6.72 6.72 3.705 0 6.72-3.015 6.72-6.72 0-3.705-3.015-6.72-6.72-6.72zm2 3.387c.736 0 1.333.597 1.333 1.333v4c0 .736-.597 1.333-1.333 1.333H6c-.736 0-1.333-.597-1.333-1.333V6c0-.736.597-1.333 1.333-1.333h4z",
    transform: "translate(755 281) translate(10 7)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedStatus);
export default __webpack_public_path__ + "static/media/completed-status.c70f6ee4ddf03857d7cc7a9bf81ee465.svg";
export { ForwardRef as ReactComponent };